/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-03 09:04:00
 * @LastEditTime: 2020-10-09 14:17:38
 * @Description: 部门store
 */
import Vue from 'vue'
import {
    getDepartmentList,
    createDepartment,
    updateDepartment
} from '@/api/department'

const state = {
    departmentList: []
}

const getters = {
    getDepartmentById: (state) => (id) => {
        let index = state.departmentList.findIndex(x => x._id === id)
        return index === -1 ? null : state.departmentList[index]
    },
    getTreeDepartment: (state) => (disabled) => {
        const root = {
            title: '全部',
            expand: true,
            children: []
        }
        if (state.departmentList.length === 0) return [root]
        let convertedDepart = state.departmentList.map(e => {
            return {
                ...e,
                title: e.name,
                expand: true
            }
        })

        let trans = (depart, parent) => {
            let finalDepart = []

            for (let v of depart) {
                if (v.parent == parent) {
                    finalDepart.push(v)
                }
            }

            finalDepart.forEach(e => {
                e.children = trans(convertedDepart, e._id);
                e.disabled = disabled && e.children.length !== 0
            })
            return finalDepart
        }

        return [{
            ...root,
            children: trans(convertedDepart),
            disabled
        }]
    },
    getTreeSelectDepartment: (state) => (disabled, selectArray) => {
        const root = {
            title: '全部',
            expand: true,
            children: []
        }
        if (state.departmentList.length === 0) return [root]
        let convertedDepart = state.departmentList.map(e => {
            return {
                ...e,
                title: e.name,
                expand: true
            }
        })

        let trans = (depart, parent) => {
            let finalDepart = []

            for (let v of depart) {
                if (v.parent == parent) {
                    finalDepart.push(v)
                }
            }

            finalDepart.forEach(e => {
                e.children = trans(convertedDepart, e._id);
                e.disabled = disabled && e.children.length !== 0
                if (selectArray) e.checked = selectArray.includes(e._id)
            })
            return finalDepart
        }

        return [{
            ...root,
            children: trans(convertedDepart),
            disabled
        }]
    },
    getDepartmentByType: (state) => (type) => {
        return state.departmentList.filter(x => x.type[type] === true)
    }
}

const actions = {
    async getDepartmentListAction({
        commit
    }, payload) {
        try {
            const department = await getDepartmentList(payload)
            commit('SETDEPARTMENT', department.data)
            return department.data
        } catch (error) {
            throw error.message
        }
    },
    async createDepartmentAction({
        commit
    }, payload) {
        try {
            const newDepartment = await createDepartment(payload)
            commit('ADDNEWDEPARTMENT', newDepartment.data)
        } catch (error) {
            throw error.message
        }
    },
    async updateDepartmentAction({
        commit
    }, payload) {
        try {
            const newDepartment = await updateDepartment(payload.id, payload.data)
            commit('UPDATEDEPARTMENT', newDepartment.data)
            return newDepartment.data
        } catch (error) {
            throw error.message
        }
    }

}

const mutations = {
    SETDEPARTMENT(state, payload) {
        state.departmentList = payload
    },
    ADDNEWDEPARTMENT(state, department) {
        state.departmentList.unshift(department)
    },
    UPDATEDEPARTMENT(state, department) {
        Vue.set(state.departmentList, state.departmentList.findIndex(x => x._id === department._id), department)
    },
    REMOVEDEPARTMENT(state, departmentId) {
        state.currentDepartment = state.currentDepartment.filter((e) => e._id !== departmentId)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}